export default __webpack_public_path__ + "assets/facade-moderne-etages-quebec.baf6033e.webp";